import { useRef } from 'react'


import { zodResolver } from '@hookform/resolvers/zod'
import _ from 'lodash'
import ReCAPTCHA from 'react-google-recaptcha'
import { useForm, FormProvider } from 'react-hook-form'



import { useTranslation } from '@/shared/hooks/useTranslation'
import { getErrorMessage, showErrorAlert } from '@/shared/lib/errors'
import { Button } from '@/shared/ui'
import { AppIcon  } from '@/shared/ui/icons'
import { Overlay } from '@/shared/ui/Overlay'

import { useAuthContext } from '../model/auth-context'
import { forgotPasswordSchema } from '../model/schemas'
import { ForgotPasswordFields } from './fields/ForgotPasswordFields'

export const ForgotPasswordForm = () => {
  const reCaptchaRef = useRef<ReCAPTCHA>(null)
  const {
    httpClient,
    isLoading,
    styleConfig,
    config,
    goToSignIn,
    setCurrentEmail,
    reCaptchaEnabled,
    goToResetPassword,
    getDefaultValues,
    useReCaptchaV3,
    reCaptchaKey,
    setIsLoading
  } = useAuthContext()
  const header =
    _.has(config, 'forgotPassword.header') &&
    _.get(config, 'forgotPassword.header', {})
  const methods = useForm({
    defaultValues: getDefaultValues(),
    resolver: zodResolver(forgotPasswordSchema)
  })

  const { t } = useTranslation()

  const handleRequestPasswordReset = async data => {
    if (isLoading) return

    setIsLoading(true)
    const { email } = data

    setCurrentEmail(email)

    try {
      await httpClient.post('/auth/reset-password', {
        email
      })

      goToResetPassword({ email })
    } catch (error) {
      const { errors } = getErrorMessage(error)

      if (_.get(errors, 'errors.email'))
        methods.setError('email', {
          type: 'manual',
          message: `E-mail ${_.get(errors, 'errors.email', []).join(', ')}`
        })
      else showErrorAlert(error)
    }

    setIsLoading(false)
  }

  return (
    <Overlay
      block
      show={false}
      active={isLoading}
      opacity="50"
      layer={
        <AppIcon name="spinner-third" className="animate-spin text-brand text-2xl" />
      }
    >

      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleRequestPasswordReset)}>
          <ForgotPasswordFields />

          {reCaptchaEnabled && (
            <div className="flex items-center justify-center w-full">
              <ReCAPTCHA
                ref={reCaptchaRef}
                sitekey={reCaptchaKey}
                size={useReCaptchaV3 ? 'invisible' : 'normal'}
              />
            </div>
          )}
          {/* O caminho de volta vive no rodapé da página; com o "Cancelar"
              aqui, a tela oferecia duas saídas para o mesmo lugar. */}
          <div className="mb-10 mt-8 flex items-center justify-center">
            <Button
              type="submit"
              variant="primary"
              className="w-full"
              loading={isLoading}
              showTrailingIcon={false}
            >
              {isLoading
                ? t('buttons.reseting', {}, { fallback: 'Resetando...' })
                : t('buttons.reset', {}, { fallback: 'Resetar' })}
            </Button>
          </div>
        </form>
      </FormProvider>
    </Overlay>
  )
}
